import React from 'react';
import { Link } from 'react-router-dom';

export default function CareerExperience() {
  const leftPerks = [
    {
      icons: "/assets/images/career-icons1.webp",
      title: "Career Growth",
      description:
        "Clear advancement paths, structured mentorship programs, and continuous skill development across all roles. We invest in your professional journey, provide leadership exposure, and celebrate your progress toward long-term success.",
    },
    {
      icons: "/assets/images/career-icons2.webp",
      title: "Learning Culture",
      description:
        "Gain access to ongoing training programs, industry-recognized certifications, workshops, and collaborative knowledge-sharing sessions. Our culture encourages curiosity, innovation, and continuous improvement to help you stay ahead in an ever-evolving industry.",
    },

  ];

  const rightPerks = [
    {
      icons: "/assets/images/career-icons3.webp",
      title: "Impactful Work",
      description:
        "Lead and contribute to meaningful projects that directly shape Supershine's vision and create measurable impact. Your ideas, efforts, and expertise drive real change, helping us deliver excellence while making a difference at scale.",
    },
    {
      icons: "/assets/images/career-icons4.webp",
      title: "Collaborative Team",
      description:
        "Work alongside talented, driven, and supportive colleagues who value teamwork, transparency, and shared success. We foster an environment where diverse perspectives are respected, innovation thrives, and achievements are celebrated together.",
    },


  ];

  return (

    <>
      <section className="carrer-perk">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-12 col-lg-8">
              <div className="perk-wrapper">
                <h2 className="heading ">
                  Join the Force <br /> Behind  Supershine’s  Success
                </h2>
              </div>
            </div>
            <div className="col-lg-5 col-md-6 col-sm-12">
              {leftPerks.map((perk, index) => (
                <div className="carrer-perk-box" key={index}>
                  <div className="icon-wrapper">
                    <img src={perk.icons} alt="Icon" className="img-responsive" />
                  </div>
                  <label className="subtitle">{perk.title}</label>
                  <p>{perk.description}</p>
                </div>
              ))}
            </div>

            <div className="col-lg-5 col-md-6 col-sm-12">
              {rightPerks.map((perk, index) => (
                <div className="carrer-perk-box" key={index}>
                  <div className="icon-wrapper">
                    <img src={perk.icons} alt="Icon" className="img-responsive" />
                  </div>
                  <label className="subtitle">{perk.title}</label>
                  <p>{perk.description}</p>
                </div>
              ))}

  
            </div>
         <div className='col-lg-12 text-center'>
          <div className='careere-ctc'>
            <span>
              To join our team send your resume to{" "}
              <Link to="mailto:sales@supershinelaundry.ae">
                sales@supershinelaundry.ae
              </Link>
            </span>
          </div>
        </div>
              
          </div>
        </div>

      </section>
      {/* <div className="carrer-bigimage">
        <img src="/assets/images/career-aplication-img.webp" className="img-responsive" alt="carrer" loading="lazy" />
      </div> */}
    </>
  )
}

